// VERIFIED (default): data from an official filing, e.g. MCA.
// NEUTRAL (grey): Overview cards whose data is gathered externally — News Sites, Web Search, EPFO.
export const SOURCE_BADGE_TONE = { VERIFIED: 'verified', NEUTRAL: 'neutral' } as const;
